import { NoticeModal, UserMessage } from '@lili/lili-frontend-common';
import { useCallback } from 'react';
import { ModalTypes } from '@Hooks/modalManager/modal.types.ts';
import { useModal } from '@Hooks/modalManager/useModal.ts';
import { Icon, Icons } from '@Components/icon/Icon.tsx';

export const ModalRenderer = () => {
  const { setModal, modalState } = useModal();

  const renderModal = useCallback(() => {
    switch (modalState.type) {
      case ModalTypes.GENERAL:
        return (
          <NoticeModal
            buttonText={modalState.buttonText || ''}
            secondaryButtonText={modalState.button2Text}
            secondaryOnSubmit={modalState.onCancel}
            image={<Icon icon={modalState.icon ?? Icons.Oops} />}
            title={modalState.title || ''}
            id='id'
            content={modalState.content}
            onSubmit={modalState.onSubmit}
            onClickOutside={() => {}}
            shouldPersist
          />
        );

      case ModalTypes.CUSTOM:
        return modalState.customComponent;

      default:
        return null;
    }
  }, [modalState]);

  return modalState.isActive ? (
    <UserMessage
      blur={modalState.blur}
      contentWrapperClassName='w-fit md:w-fit px-[16px]'
      onClick={
        modalState.persistModal
          ? () => {}
          : () => setModal({ isActive: false, type: ModalTypes.NONE })
      }
      id='modalManager'>
      {renderModal()}
    </UserMessage>
  ) : null;
};
